import { render, staticRenderFns } from "./ComplianceManagement.vue?vue&type=template&id=fb5aedc4&scoped=true"
import script from "./ComplianceManagement.vue?vue&type=script&lang=js"
export * from "./ComplianceManagement.vue?vue&type=script&lang=js"
import style0 from "./ComplianceManagement.vue?vue&type=style&index=0&id=fb5aedc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5aedc4",
  null
  
)

export default component.exports